  /* ============================================
     KOMPONEN: Flyout Panel (mini mode accordion)
     ============================================ */

import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";

  
export const FlyoutPanel = ({ item, isActive, onNavigate, onClose }) =>  {
    const panelRef = useRef(null);
    const Icon = item.icon;
  
    // Tutup flyout saat klik di luar
    useEffect(() => {
      const handleClick = (e) => {
        if (panelRef.current && !panelRef.current.contains(e.target)) {
          onClose();
        }
      };
      // Delay agar click trigger tidak langsung tertutup
      const timer = setTimeout(() => {
        document.addEventListener("mousedown", handleClick);
      }, 10);
      return () => {
        clearTimeout(timer);
        document.removeEventListener("mousedown", handleClick);
      };
    }, [onClose]);
  
    return (
      <div
        ref={panelRef}
        className="absolute left-full top-0 w-56 z-[9998]"
        style={{ animation: "flyoutIn 0.2s ease-out" }}
      >
        <div
          className="rounded-xl overflow-hidden"
          style={{
            background: "rgba(11, 20, 38, 0.97)",
            border: "1px solid rgba(0, 180, 216, 0.15)",
            boxShadow: "0 20px 50px rgba(0, 0, 0, 0.5), 0 0 30px rgba(0, 180, 216, 0.08)",
            backdropFilter: "blur(20px)",
          }}
        >
          {/* Header */}
          <div
            className="flex items-center gap-2.5 px-4 py-3"
            style={{ borderBottom: "1px solid rgba(51, 65, 85, 0.3)" }}
          >
            <div className="w-7 h-7 rounded-lg bg-ocean-600/15 border border-ocean-500/20 flex items-center justify-center">
              <Icon className="text-xs text-ocean-400" />
            </div>
            <span className="text-sm font-semibold text-ocean-400">{item.name}</span>
          </div>
  
          {/* Links */}
          <div className="p-2 space-y-0.5">
            {item.subItems?.map((subItem) => {
              const subActive = isActive(subItem.path);
              return (
                <Link
                  key={subItem.id}
                  to={subItem.path}
                  onClick={() => {
                    onNavigate();
                    onClose();
                  }}
                  className={`flex items-center gap-2.5 px-3 py-2.5 rounded-lg transition-all duration-150 ${subActive
                    ? "bg-ocean-600/12 text-ocean-400"
                    : "text-slate-400 hover:text-white hover:bg-slate-700/40"
                    }`}
                >
                  {subActive && (
                    <span className="w-1.5 h-1.5 rounded-full bg-ocean-500 flex-shrink-0" />
                  )}
                  {!subActive && <span className="w-1.5 flex-shrink-0" />}
                  <span className="text-[13px] font-medium">{subItem.name}</span>
                </Link>
              );
            })}
          </div>
        </div>
  
        {/* Arrow */}
        <div
          className="absolute top-4 -left-1.5"
          style={{
            width: 0, height: 0,
            borderTop: "6px solid transparent",
            borderBottom: "6px solid transparent",
            borderRight: "6px solid rgba(0, 180, 216, 0.15)",
          }}
        />
      </div>
    );
  }